// extracted by mini-css-extract-plugin
export default {"nav":"Navigation_nav__-LEKO","shrink":"Navigation_shrink__QU8He"};